/*
  MIT License

  Copyright (c) 2022 Open Source  UOM

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.

  Made by Open Source UoM (https://opensource.uom.gr)

  Project members:
    -Apostolidis
    -Davios
    -Iosifidis
    -Konstantinidis
    -Mpakalis
    -Nasis
    -Omiliades
    -Patsouras
    -Fakidis

*/

import { DEPARTMENT_CODES } from "./DepNames";



export const AnnouncementsData = [
  {
    code: DEPARTMENT_CODES.BALKAN_STUDIES,
    link: "https://www.uom.gr/bso/ta-nea-mas",

  },
  {
    code: DEPARTMENT_CODES.EUROPEAN_STUDIES,
    link: "https://www.uom.gr/ies#undefined1",
  },
  {
    code: DEPARTMENT_CODES.EDUCATION,
    link: "https://www.uom.gr/esp",
  }, {
    code: DEPARTMENT_CODES.INFORMATICS,
    link: "https://www.uom.gr/dai/ta-nea-toy-tmhmatos",
  }, {
    code: DEPARTMENT_CODES.BUSINESS_ADMINISTRATION,
    link: "https://www.uom.gr/ba",
  }, {
    code: DEPARTMENT_CODES.ECONOMICS,
    link: "https://www.uom.gr/eco#undefined1",
  }, {
    code: DEPARTMENT_CODES.FINANCE,
    link: "https://www.uom.gr/fin",
  }, {
    code: DEPARTMENT_CODES.MUSIC,
    link: "https://www.uom.gr/msa",
  }

]


// AnnouncementsData.set(DEPARTMENTS[0], "https://www.uom.gr/bso/ta-nea-mas")
// AnnouncementsData.set(DEPARTMENTS[1], "https://www.uom.gr/ies#undefined1")
// AnnouncementsData.set(DEPARTMENTS[2], "https://www.uom.gr/esp")
// AnnouncementsData.set(DEPARTMENTS[3], "https://www.uom.gr/dai/ta-nea-toy-tmhmatos")
// AnnouncementsData.set(DEPARTMENTS[4], "https://www.uom.gr/fin")
// AnnouncementsData.set(DEPARTMENTS[5], "https://www.uom.gr/msa")
// AnnouncementsData.set(DEPARTMENTS[6], "https://www.uom.gr/eco#undefined1")
// AnnouncementsData.set(DEPARTMENTS[7], "https://www.uom.gr/ba")
